<template>
  <div id="app" class="image-container set-full-height">
    <fresh-relevance-tracking />
    <header-menu />
    <router-view />
    <help-modal />
  </div>
</template>

<script>
import HelpModal from "@/components/ui/HelpModal.vue";
import HeaderMenu from "@/components/ui/Header.vue";
import FreshRelevanceTracking from "@/components/freshRelevance/FreshRelevanceTrackingTag.vue";
import { initDatadog } from "@/helper/datadog";
export default {
  components: {
    "help-modal": HelpModal,
    "header-menu": HeaderMenu,
    "fresh-relevance-tracking": FreshRelevanceTracking,
  },
  created() {
    this.$store.dispatch("setCountryCodes");
    this.$store.dispatch("setTimeScales");
    this.$store.dispatch("setBudgetValues");
    this.$store.dispatch("setOpportunityTypes");
    this.$store.dispatch("setFundtinOptions");
    this.$store.dispatch("setCurrencies");
    this.$store.dispatch("setRfts");
    initDatadog();
  },
};
</script>
